function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import Svg from './Svg';
import styled from 'styled-components';
const BaseComponent = _ref => {
  let {
    size,
    title,
    desc,
    titleId,
    descId,
    ...props
  } = _ref;
  let ariaLabelledBy = titleId ? titleId : '';
  ariaLabelledBy += desc && descId ? ` ${descId}` : '';
  ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
  props['aria-labelledby'] = ariaLabelledBy;
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: size,
    height: size,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    title: title,
    titleId: titleId,
    desc: desc,
    descId: descId,
    "aria-labelledby": ariaLabelledBy,
    "aria-hidden": !ariaLabelledBy,
    fill: "currentcolor"
  }, props), !!title && /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title), !!desc && /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.316 9.363C12.897 8.703 12.344 8.171 11.66 1 10.976 8.17 10.422 8.702 3 9.363c7.422.657 7.976 1.196 8.66 8.363.684-7.167 1.237-7.706 8.656-8.363zM8.6 16.623c-.261 2.73-.473 2.934-3.298 3.187 2.825.248 3.037.457 3.298 3.19.257-2.733.469-2.942 3.298-3.19-2.83-.253-3.04-.457-3.298-3.187zM18.855 15.557c.17-1.774.308-1.905 2.145-2.072-1.837-.163-1.975-.293-2.145-2.068-.169 1.775-.307 1.905-2.144 2.068 1.837.167 1.975.298 2.144 2.072z"
  })));
};
const SvgSparkle = styled(BaseComponent).withConfig({
  displayName: "Sparkle__SvgSparkle",
  componentId: "sc-cg7685-0"
})(["outline:none;"]);
SvgSparkle.isIcon = true;
SvgSparkle.defaultProps = {
  size: 24,
  tabIndex: -1,
  focusable: false,
  'aria-hidden': true,
  role: 'img'
};
export default SvgSparkle;